module.exports = __webpack_public_path__ + "img/ic_medium_artikel-active.59911f2b.svg";